/**
 * Alignable parts of a status across both horizontal and vertical axes
 *
 * ```
 * ┄┄╭――――――――――――――――╮┄┄┄┄┄ top
 *   |                |
 * ┄┄╰――――――――――――――――╯┄┄┄┄┄ bottom
 *
 * left   middle   right
 * ┆        ┆        ┆
 * ╭――――――――┆――――――――╮
 * |        ┆        |
 * ╰――――――――┆――――――――╯
 * ┆        ┆        ┆
 * ```
 */
export type Bounds = {
	left: number;
	right: number;
	top: number;
	bottom: number;
	/**
	 * Horizontal center of a status
	 *
	 * ```
	 *        middle
	 *          ┆
	 * ╭――――――――┆――――――――╮
	 * |        ┆        |
	 * ╰――――――――┆――――――――╯
	 *          ┆
	 * ```
	 */
	middle: number;
};

// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum HorizontalAlignment {
	left = 'left',
	middle = 'middle',
	right = 'right',
}

// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum VerticalAlignment {
	top = 'top',
	bottom = 'bottom',
}

export type HorizontalSnapLine = {
	type: 'horizontal';
	x: number;
	top: number;
	bottom: number;
	alignment: HorizontalAlignment;
};

export type VerticalSnapLine = {
	type: 'vertical';
	y: number;
	left: number;
	right: number;
	alignment: VerticalAlignment;
};

/** A line on an axis that can be snapped */
export type SnapLine = HorizontalSnapLine | VerticalSnapLine;

export type HorizontalSnappable = {
	type: 'horizontal';
	x: number;
	alignment: HorizontalAlignment;
	top: number;
	bottom: number;
};

export type VerticalSnappable = {
	type: 'vertical';
	y: number;
	alignment: VerticalAlignment;
	left: number;
	right: number;
};

/** A possible snap line for an individial item that can be snapped to */
export type Snappable = HorizontalSnappable | VerticalSnappable;
